import { render, staticRenderFns } from "./InfinityUpgradesTab.vue?vue&type=template&id=c6393b0e&scoped=true"
import script from "./InfinityUpgradesTab.vue?vue&type=script&lang=js"
export * from "./InfinityUpgradesTab.vue?vue&type=script&lang=js"
import style0 from "./InfinityUpgradesTab.vue?vue&type=style&index=0&id=c6393b0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6393b0e",
  null
  
)

export default component.exports